/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

$(document).ready(function() {
    if (Shopify.locale == 'fr') {
        // Set a timeout of 2000 milliseconds (2 seconds)
        setTimeout(function() {
            if ($('a.zmsg').length) {
                              $('a.zmsg').attr('href', 'https://eclipse-dev.myshopify.com/fr/account/login'); // Change this to your desired URL

                $('a.zmsg').text('Veuillez vous connecter pour enregistrer, partager et gérer votre liste de souhaits');
            }
        }, 1000); // Adjust the time as needed
    }
});


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // // Fired when page loads to update header values
  //   document.addEventListener('theme:cart:init', (e) => {
  //     console.log('theme:cart:init');
  //     console.log(e);
  //   });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
    document.addEventListener('theme:scroll', e => {
      if(e.detail.position !== 0){
        document.querySelectorAll('.search-bar-outer-wrap')[1].classList.add('no-pad');
      }
      else{
        document.querySelectorAll('.search-bar-outer-wrap')[1].classList.remove('no-pad');
      }
    });
    // document.addEventListener('theme:scroll:up', e => { console.log(e); });
    // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // // Debounced resize listener to bundle changes that trigger document reflow
  //   document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  
})();

//Size chart toggle
const checkbox_size_chart = document.getElementById('size-chart-toggle-btn');
if(checkbox_size_chart){
  checkbox_size_chart.addEventListener('change', (event) => {
    if (event.currentTarget.checked) {
      document.querySelectorAll('.tab-content-sz')[0].classList.remove("in");
      document.querySelectorAll('.tab-content-sz')[0].classList.add("cm");
    } else {
      document.querySelectorAll('.tab-content-sz')[0].classList.remove("cm");
      document.querySelectorAll('.tab-content-sz')[0].classList.add("in");
      
    }
  });
  function tab_chart(obj){
    for(i=0; i<4;i++){
      document.querySelectorAll('.tab-wrap .tabs ul li')[i].classList.remove('active');
      document.querySelectorAll('.tab-content-sz .content-sz')[i].style.display = 'none';
    }
    document.querySelectorAll('.tab-wrap .tabs ul li')[obj].classList.add('active');
    document.querySelectorAll('.tab-content-sz .content-sz')[obj].style.display = 'block';
  }
}
let checkFrPathName= location.pathname.split('/')[1];
if(checkFrPathName === 'fr'){
  $('.size-wrap .image-wrap .image.en').hide();
  $('.size-wrap .image-wrap .image.fr').show();
}
// trigger click seacrh icon from ipad layout
var _ipad_search_icon = document.getElementById('ipad_search_icon');
_ipad_search_icon.addEventListener('click', (event) => {
  event.preventDefault();
  document.getElementById('desktop_search_icon').click();
});

//Search page grid switch
var _grid_icons_search = document.querySelectorAll('.search_page_grid_switch button');
_grid_icons_search.forEach(btn => {
  btn.addEventListener('click', (e) => {
    document.getElementsByClassName('js-grid')[0].setAttribute("data-grid-large", btn.getAttribute("data-toggle-grid"));
    document.getElementsByClassName('js-grid')[0].setAttribute("data-grid-small", btn.getAttribute("data-toggle-grid"));
  }
    ) ;
});

//Load more products collection
var _load_more_button = document.querySelector('[data-load-more]');
if(_load_more_button){
  _load_more_button.addEventListener('click', (e) => {
    _isPaginationFilter = true;
    _load_more_button.classList.add('is-loading');
    if(document.getElementById('pagination-next-page')){
      document.getElementById('pagination-next-page').click();
    }
  });
}

//Quick add to cart product card
// window.addEventListener("DOMContentLoaded", (event) => {
//   var _quickATC_container = document.querySelectorAll('.product-grid-item');
//   if(_quickATC_container){
//     _quickATC_container.forEach(el => {
//       el.querySelector('.quick-add-small').addEventListener('click', (e) =>{
//         el.classList.add('show');
//       });
//       el.querySelector('.close').addEventListener('click', (e) =>{
//         el.classList.remove('show');
//       });
//       // el.querySelector('.inline__variant__add').addEventListener('click', (e) =>{
//       //   el.classList.remove('show');
//       // });
//     });
//   }
// });
$(function(){
  const $body = document.querySelector('body');
  let scrollPosition = 0;
  $(document).on('click', '.product-grid-item .quick-add-small', function(){
    
    $(this).parent().parent().closest('.product-grid-item').addClass('show');
    scrollPosition = window.pageYOffset;
    $body.style.top = `-${scrollPosition}px`;
    $body.style.width = '100%';
  });
  $(document).on('click', '.product-grid-item .close', function(){
    $(this).parent().parent().parent().closest('.product-grid-item').removeClass('show');
    $body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  });

  //collection page change swatch price
  $(document).on('click', '.product-grid-item .grid__swatch__container .swatch__button', function(){
    let _compareat_price = $(this).data('compareat-price'), _price = $(this).data('price');

    if(_compareat_price != _price){
      $(this).parent().parent().parent().find('.product__grid__price.listing_page_grid .product__grid__cutline').nextAll().remove();
      $(this).parent().parent().parent().find('.product__grid__price.listing_page_grid').append('<span class="compare-at">$'+_compareat_price/100+'</span><span class="price on-sale">$'+_price/100+'</span>');
    }
    else{
      $(this).parent().parent().parent().find('.product__grid__price.listing_page_grid .product__grid__cutline').nextAll().remove();
      $(this).parent().parent().parent().find('.product__grid__price.listing_page_grid').append('<span class="price">$'+_price/100+'</span>');
    }
  });

  $('.mobile__head__level__2').on('click', function(){
    // $(this).next(".mobile_level__2").slideToggle();
    // $(this).parent().siblings(".sliderule__wrapper").find(".mobile_level__2:visible").slideUp();
    // $(this).parent().siblings(".sliderule__wrapper").find(".mobile__head__level__2").removeClass("active");
    // $(this).toggleClass("active");
  });
  $('.collection__filters__toggle').on('click', function(){
    setTimeout(() => {
      if($(this).hasClass('drawer--visible')){
        localStorage.setItem('filter_state_plp', true);
      }
      else{
        localStorage.setItem('filter_state_plp', false);
      }
    }, 10);
  });
  let _filter_state_plp_localstorage = localStorage.getItem('filter_state_plp');
  let vw = $(window).width();
  if(_filter_state_plp_localstorage == 'true' && vw > 1023){
    setTimeout(() => {
      $('.collection__filters__toggle').addClass('filters--default-visible drawer--visible');
      $('.collection__filters__toggle').attr('aria-expanded', true);
      $('.collection__filters__wrapper').addClass('filters--default-visible drawer--visible');
      $('.collection__filters__wrapper').removeClass('hidden');
    }, 100);
  } 
  $('[data-toggle-grid]').on('click', function(){
    let currGrid = $(this).data('toggle-grid');
    localStorage.setItem('user_grid_style', currGrid);
      let _user_selected_grid_plp = localStorage.getItem('user_grid_style');
  if(_user_selected_grid_plp){
    setTimeout(() => {
      $('.collection__products .js-grid').attr('data-grid-large', _user_selected_grid_plp);
      $('.collection__products .js-grid').attr('data-grid-tablet', _user_selected_grid_plp);
      $('.collection__products .js-grid').attr('data-grid-small', _user_selected_grid_plp);
    },100);
  }
  });
  let _user_selected_grid_plp = localStorage.getItem('user_grid_style');
  if(_user_selected_grid_plp){
    setTimeout(() => {
      $('.collection__products .js-grid').attr('data-grid-large', _user_selected_grid_plp);
      $('.collection__products .js-grid').attr('data-grid-tablet', _user_selected_grid_plp);
      $('.collection__products .js-grid').attr('data-grid-small', _user_selected_grid_plp);
    },100);
  }
  $('[data-sort-link]').on('click', function(){
   // // alert('333333333333')
    let currSort = $(this).data('value');
    localStorage.setItem('user_sort_option', currSort);
    $('.header__menu a, .footer__content .grid__item:eq(0) a, .mobile__menu__dropdown a').each(function(){
      let _href = $(this).attr('href');
      if (_href) {
        _href = _href.split('?');
        let _href_sliced = _href[0]+'?sort_by=' + currSort;
        // console.log(_href_sliced);
        $(this).attr('href', _href_sliced);
      }
    });
  });
  let _user_selected_sort_plp = localStorage.getItem('user_sort_option');

  if(_user_selected_sort_plp){
    $('a').each(function(){
      let _href = $(this).attr('href');
      let _is_collection = _href.search("collections");
      if (_href && _is_collection != -1) {
        _href += '?sort_by=' + _user_selected_sort_plp;
        $(this).attr('href', _href);
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
     const selectors$Z = {
    dataQuickview: 'data-quickview',
    quickviewHolder: 'data-quickview-holder',
    addButtonWrapper: '[data-add-action-wrapper]',
    modalContent: '[data-product-quickview-ajax]',
    quickviewModal: '[data-quickview-modal]',
    quickviewModalScrolls: '[data-drawer-scrolls]',
    quickviewModalTemplate: '[data-quickview-modal-template]',
    quickviewHead: '[data-quickview-head]',
    quickviewFormArea: '[data-quickview-form-area]',
    toggleButton: '[data-toggle-button]',
    media: '[data-media-slide]',
    mediaId: '[data-media-id]',
    dataPopup: 'data-popup-',
    focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  };
  const addActionWrapper = document.querySelector('[data-add-action-wrapper]');

  if (addActionWrapper) {
    addActionWrapper.addEventListener('click', () => {
      // // alert('3333333333333333333333333');
      
      const quickviewHolder = addActionWrapper.querySelector(`[${selectors$Z.quickviewHolder}]`);
      let modalTemplate, modal, modalID, modalContent, modalScroll, scrollLockEnable, windowH, triggerButton, handle;

      if (quickviewHolder) { 
        // alert('test')
        modalTemplate = quickviewHolder.querySelector(selectors$Z.quickviewModalTemplate);
        modal = document.querySelector(selectors$Z.quickviewModal);
        modalID = quickviewHolder.getAttribute(selectors$Z.quickviewHolder);
        modalContent = null;
        modalScroll = null;
        scrollLockEnable = true;
        windowH = window.innerHeight;

        triggerButton = quickviewHolder.querySelector(`[${selectors$Z.dataPopup}${modalID}]`);
        handle = triggerButton ? triggerButton.getAttribute(`${selectors$Z.dataPopup}${modalID}`) : null;

        if (modalTemplate && !modal) {
          const modalTemplateInner = modalTemplate.innerHTML;
          const htmlObject = document.createElement('div');
          htmlObject.innerHTML = modalTemplateInner;
          const modalHtml = htmlObject.querySelector(selectors$Z.quickviewModal);
          document.body.appendChild(modalHtml);
          modal = document.querySelector(selectors$Z.quickviewModal);
        }

        if (modalTemplate && triggerButton) {
          triggerButton.addEventListener('click', (e) => {
            e.preventDefault();

            if (modal && modalID) {
              modal.id = modalID;
            }

            if (document.documentElement.hasAttribute('data-scroll-locked')) {
              scrollLockEnable = false;
            }

            addActionWrapper.classList.add(classes$B.loading);

            fetchQuickviewHTML(handle, modal, modalContent, quickviewHolder, scrollLockEnable);
          });
        }
      }
    });
  }
});

function fetchQuickviewHTML(handle, modal, modalContent, quickviewHolder, scrollLockEnable) {
  window
    .fetch(`${window.theme.routes.root_url}products/${handle}?section_id=api-product-quickview`)
    .then((response) => response.text())
    .then((response) => {
      const fresh = document.createElement('div');
      fresh.innerHTML = response;
      modalContent = modal.querySelector(selectors$Z.modalContent);
      modalContent.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
      const images = modalContent.querySelector(selectors$Z.mediaId);

      if (images) {
        const imagesHolder = document.createElement('div');
        imagesHolder.innerHTML = images.parentElement.innerHTML;
        quickviewHolder.dispatchEvent(
          new CustomEvent('theme:quickview:media', {
            bubbles: true,
            detail: { media: imagesHolder },
          })
        );
      }

      modalCreate(modal, modalID, scrollLockEnable);
      addActionWrapper.classList.remove(classes$B.loading);
    });
}

function modalCreate(modal, modalID, scrollLockEnable) {
  MicroModal.show(modalID, {
    onShow: (modal) => {
      const quickviewHead = modal.querySelector(selectors$Z.quickviewHead);
      const quickviewFormArea = modal.querySelector(selectors$Z.quickviewFormArea);
      const toggleButton = modal.querySelector(selectors$Z.toggleButton);

      toggleForm(quickviewHead, quickviewFormArea, toggleButton);
    },
    onClose: (modal) => {
      const allMedia = modal.querySelectorAll(selectors$Z.media);
      allMedia.forEach((media) => media.dispatchEvent(new CustomEvent('pause')));

      if (scrollLockEnable) {
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      } else {
        scrollLockEnable = true;
      }
    },
  });
}

function toggleForm(quickviewHead, quickviewFormArea, toggleButton) {
  const windowH = window.innerHeight;

  if (!toggleButton.classList.contains(classes$B.hide)) {
    toggleButton.classList.add(classes$B.hide);
  }

  if (!quickviewFormArea.classList.contains(classes$B.expanded)) {
    quickviewFormArea.classList.add(classes$B.expanded);
  }

  setTimeout(() => {
    const visiblePart = windowH - quickviewHead.offsetHeight - quickviewFormArea.offsetHeight;
    const hasMediumVisiblePart = visiblePart < visibleParts.mediumPart && visiblePart > visibleParts.minPart;
    const missingVisiblePart = visiblePart < visibleParts.minPart;

    if (hasMediumVisiblePart || missingVisiblePart) {
      toggleButton.classList.remove(classes$B.hide);
      toggleButton.classList.add(classes$B.active);
    } else {
      toggleButton.classList.add(classes$B.hide);
    }

    if (missingVisiblePart) {
      quickviewFormArea.classList.remove(classes$B.expanded);
      toggleButton.classList.remove(classes$B.active);
    } else {
      quickviewFormArea.classList.add(classes$B.expanded);
    }
  }, 200);
}
document.addEventListener("DOMContentLoaded", function () {
    const slides = document.querySelectorAll('.announcement__bar');
    const slideInterval = 5000; // 5 seconds
    let currentIndex = 0;

    function showSlide(index) {
        slides.forEach((slide, i) => {
            slide.classList.remove('active', 'previous', 'next');
            if (i === index) {
                slide.classList.add('active'); // Set current slide to active
            } else if (i === (index - 1 + slides.length) % slides.length) {
                slide.classList.add('previous'); // Set previous slide
            } else if (i === (index + 1) % slides.length) {
                slide.classList.add('next'); // Set next slide
            }
        });
    }

    function startSlider() {
        setInterval(() => {
            currentIndex = (currentIndex + 1) % slides.length;
            showSlide(currentIndex);
        }, slideInterval);
    }

    // Initialize the slider
    showSlide(currentIndex);
    startSlider();
});

